<template>
    <div style="max-width: 560px;">
        <Developing/>
    </div>
</template>

<script>
    import Developing from "../../../../comps/Developing";

    export default {
        name: "Naming",
        components: {Developing},
        props: {album: Object},
    }
</script>
